<template>
    <v-dialog v-model="dialog" width="600px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Create/Edit Virtual conversation</v-card-title>
            <v-divider></v-divider>
            <cardWait message="Creating Conversation ... " v-if="disabled"/>
            <v-card-text class="py-2 px-5">
                <v-row>
                    <v-col cols=4>Description</v-col><v-col cols=8><v-text-field v-model="conversation.description" :disabled="editMode" dense></v-text-field></v-col>
                </v-row>
                <v-row>
                    <v-col cols=4>Assistant to "talk" to</v-col><v-col cols=8><v-select v-model="conversation.assistant_id" :disabled="editMode" :items="assistants" item-value="id" item-text="name" dense></v-select></v-col>
                </v-row>
                <v-row v-if="bookingConversation">
                    <v-col cols=4>Booking numner</v-col><v-col cols=8><v-text-field v-model="bookingNr" :disabled="editMode" dense></v-text-field></v-col>
                </v-row>
                <v-row v-if="accoConversation">
                    <v-col cols=4>Accommodation numner</v-col><v-col cols=8><v-text-field v-model="accoNr" :disabled="editMode" dense></v-text-field></v-col>
                </v-row>
                <!-- <v-row>
                    <v-col cols=12><v-checkbox v-model="conversation.file_search_only" label="file search Only"></v-checkbox></v-col>
                </v-row> -->
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="disabled" small @click="saveConversation()">Save & Close</v-btn>
                <v-btn color="primary" :disabled="disabled" small @click="cancelDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import cardWait from "@/components/syst/openai/cardWait.vue";

    export default {
        components: {
            cardWait,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                editMode: true,
                disabled: false,

                bookingConversation: false,
                bookingNr: "",
                
                accoConversation: false,
                accoNr: "",
                
                assistants: [],

                conversation: {},
                orgConversation: {},
            }
        },
        methods: { 
            openDialog(conversation, assistants, bookingConversation, accoConversation) {
                this.orgConversation = {
                    description: conversation.description,
                    assistant_id: conversation.assistant_id,
                    file_search_only: conversation.file_search_only,
                } 
                this.editMode = conversation.id !== "";
                this.conversation = conversation;
                this.assistants = assistants;
                this.bookingConversation = bookingConversation;
                this.accoConversation = accoConversation;
                this.bookingNr = "";
                this.accoNr = "";
                this.dialog = true;
            },
            cancelDialog() {
                this.conversation.description = this.orgConversation.description;
                this.conversation.assistant_id = this.orgConversation.assistant_id;
                this.conversation.file_search_only = this.orgConversation.file_search_only;
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
            saveConversation() {
                if (this.conversation.assistant_id === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Please add an assistant to the conversation",
                        color: "error",
                    });  
                    return
                }
                this.disabled = true;
                this.$axios.post("ares/json/ares/syst/openai/saveConversation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveConversation",
                    },
                    saveConversation: {
                        conversation: this.conversation,
                        bookingConversation: this.bookingConversation,
                        bookingNr: this.bookingNr,
                        accoConversation: this.accoConversation,
                        accoNr: this.accoNr,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.disabled = false;
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.disabled = false;
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveConversation.text,
                            color: res.data.saveConversation.color,
                        });
                        this.$emit("updateData", res.data.saveConversation.conversation_id);
                        this.closeDialog();
                    }
                });
            },
        }
    }
</script>
